:host{display:flex;width:100%;min-height:100%}.link-style{color:var(--accent, #175CFF);text-decoration:underline}
/*# sourceMappingURL=cbc-exchange-filter-select.component-BWXFNXS4.css.map */
